import React, { useEffect, useState } from "react";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import Button from "../input/Button";
import SearchDropdown from "../input/SearchDropdown";
import LoadingSpinner from "../LoadingSpinner";

function EvInvApprovalSearchComponent({
  searchResHandler,
  setResetClicked,
  updateNeeded,
  setUpdateNeeded,
}) {
  const [typeOptions, setTypeOptions] = useState([]);
  const [singleBulkOptions, setSingleBulkOptions] = useState([]);
  const [type, setType] = useState(null);
  const [jobCode, setJobCode] = useState("");
  const [containerNo, setContainerNo] = useState("");
  const [invEvCode, setInvEvCode] = useState("");
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [customer, setCustomer] = useState("");
  const [transporter, setTransporter] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [singleBulk, setSingleBulk] = useState(1);
  const [reloadDates, setReloadDates] = useState(true);
  const [dateType, setDateType] = useState("");
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const {
        rate_type_for: statusData,
        single_bulk: typeOpt,
        date_types: dateTypeData,
      } = await getBulkDropdownData([
        { key: "rate_type_for" },
        { key: "single_bulk" },
        { key: "date_types" },
      ]);
      setDateTypeOpt(dateTypeData);
      setTypeOptions(statusData);
      setSingleBulkOptions(typeOpt);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = (e) => {
    e.preventDefault();
    searchResHandler({
      dateType: dateType ? dateType : null,
      type: type,
      jobCode: jobCode,
      invNo: invEvCode,
      fromDate: fromDate,
      toDate: toDate,
      transporter: transporter.toString(),
      customer: customer.toString(),
      vehicle: vehicle.toString(),
      singleBulk: singleBulk.toString(),
      containerNo: containerNo,
      adHoc: 1,
    });
  };

  useEffect(() => {
    if (updateNeeded) {
      searchResHandler({
        dateType: dateType ? dateType : null,
        type: type,
        jobCode: jobCode,
        invNo: invEvCode,
        fromDate: fromDate,
        toDate: toDate,
        transporter: transporter.toString(),
        customer: customer.toString(),
        vehicle: vehicle.toString(),
        singleBulk: singleBulk.toString(),
        containerNo: containerNo,
        adHoc: 1,
      });

      setUpdateNeeded(false);
    }
  }, [updateNeeded]);

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setVehicle("");
    setCustomer("");
    setTransporter("");
    setReloadDates(true);
    setInvEvCode("");
    setSingleBulk(1);
    setType(null);
    setJobCode("");
    setContainerNo("");
    setFromDate("");
    setToDate("");
    setDateType("");
    setResetClicked(true);
  };

  return (
    <>
      {dropdownLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">Invoice Search</h4>
          <div
            className="three fields"
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Dropdown
              // required={true}
              options={dateTypeOpt}
              label="Date Type"
              placeholder="Date Type"
              style={{ height: "20px" }}
              value={dateType}
              onChange={(e, data) => {
                setDateType(data.value);
              }}
              clearable={false}
            />
            <Input
              label="From Date"
              type="date"
              name="fromDate"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
            />
            <Input
              label="To Date"
              type="date"
              name="toDate"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
            />
          </div>
          <div
            className="three fields"
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Dropdown
              required={true}
              clearable={false}
              label="Single Bulk"
              placeholder="Single Bulk"
              options={singleBulkOptions}
              value={singleBulk}
              onChange={(e, data) => {
                setSingleBulk(data.value);
              }}
            />
            <Dropdown
              label="Type"
              placeholder="Type"
              options={typeOptions}
              value={type}
              onChange={(e, data) => {
                setType(data.value);
              }}
            />
            <Input
              label="Job Code"
              type="text"
              name="jobCode"
              value={jobCode}
              onChange={(e) => {
                setJobCode(e.target.value);
              }}
            />
          </div>
          <div
            className="five fields"
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Input
              label="INV/EV Code"
              type="text"
              name="invEvCode"
              value={invEvCode}
              onChange={(e) => {
                setInvEvCode(e.target.value);
              }}
            />
            <SearchDropdown
              key={1}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setCustomer(data);
              }}
              clearable={true}
              onClear={() => {
                setCustomer("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{ type: "stakeholder_type", value: "Customer" }}
              label="Customer"
            />
            <SearchDropdown
              key={1}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setTransporter(data);
              }}
              clearable={true}
              onClear={() => {
                setTransporter("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{ type: "stakeholder_type", value: "Transporter" }}
              label="Transporter"
            />
            <SearchDropdown
              key={1}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setVehicle(data);
              }}
              clearable={true}
              onClear={() => {
                setVehicle("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{ type: "vehicle", value: "" }}
              label="Vehicle"
            />
            <Input
              label="Container No"
              type="text"
              name="containerNo"
              value={containerNo}
              onChange={(e) => {
                setContainerNo(e.target.value);
              }}
            />
          </div>
          <div className="field">
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="field" style={{ width: "100%" }}>
                <Button template="search" onClick={onSearch} />
                <Button template="searchReset" onClick={onReset} />
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

export default EvInvApprovalSearchComponent;
